<template>
<div class="chapter">
<div class="inner_page">
<p class="ded" id="toc"><b>Table of Contents</b></p>
<p class="toc"><a href="#/Text/intro1">You Can Keep That to Yourself</a></p>
<p class="toc"><span href="#/Text/bio" title="Link target outside of Sample">About Adam Smyer</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?d1737cd8